import { styled, TableCell } from '@mui/material';
export const CardTableCell = styled(TableCell)({
    border: '0px',
    fontWeight: 'inherit',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    color: 'inherit',
});
